module.exports = __webpack_public_path__ + "img/AutoxAuto.a11decba.svg";